// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scroll {
  height: calc(100% - 30px);
  padding: 5px;
  position: absolute;
  right: 0;
  top: 30px;
}
.scroll .scroll-holder {
  height: calc(100%);
  margin-bottom: 5px;
  position: relative;
  width: 12px;
}
.scroll .scroll-holder .imageSlider {
  height: 12px;
  left: 12px;
  padding: 0;
  position: absolute;
  top: 0;
  -webkit-transform: rotate(90deg);
          transform: rotate(90deg);
  -webkit-transform-origin: top left;
          transform-origin: top left;
  -webkit-appearance: none;
  background-color: rgba(0, 0, 0, 0);
}
.scroll .scroll-holder .imageSlider:focus {
  outline: none;
}
.scroll .scroll-holder .imageSlider::-moz-focus-outer {
  border: none;
}
.scroll .scroll-holder .imageSlider::-webkit-slider-runnable-track {
  background-color: rgba(0, 0, 0, 0);
  border: none;
  cursor: pointer;
  height: 5px;
  z-index: 6;
}
.scroll .scroll-holder .imageSlider::-moz-range-track {
  background-color: rgba(0, 0, 0, 0);
  border: none;
  cursor: pointer;
  height: 2px;
  z-index: 6;
}
.scroll .scroll-holder .imageSlider::-ms-track {
  animate: 0.2s;
  background: transparent;
  border: none;
  border-width: 15px 0;
  color: rgba(0, 0, 0, 0);
  cursor: pointer;
  height: 12px;
  width: 100%;
}
.scroll .scroll-holder .imageSlider::-ms-fill-lower {
  background: rgba(0, 0, 0, 0);
}
.scroll .scroll-holder .imageSlider::-ms-fill-upper {
  background: rgba(0, 0, 0, 0);
}
.scroll .scroll-holder .imageSlider::-webkit-slider-thumb {
  -webkit-appearance: none !important;
  background-color: #163239;
  border: none;
  border-radius: 57px;
  cursor: -webkit-grab;
  height: 12px;
  margin-top: -4px;
  width: 39px;
}
.scroll .scroll-holder .imageSlider::-webkit-slider-thumb:active {
  background-color: #20a5d6;
  cursor: -webkit-grabbing;
}
.scroll .scroll-holder .imageSlider::-moz-range-thumb {
  background-color: #163239;
  border: none;
  border-radius: 57px;
  cursor: -moz-grab;
  height: 12px;
  width: 39px;
  z-index: 7;
}
.scroll .scroll-holder .imageSlider::-moz-range-thumb:active {
  background-color: #20a5d6;
  cursor: -moz-grabbing;
}
.scroll .scroll-holder .imageSlider::-ms-thumb {
  background-color: #163239;
  border: none;
  border-radius: 57px;
  cursor: ns-resize;
  height: 12px;
  width: 39px;
}
.scroll .scroll-holder .imageSlider::-ms-thumb:active {
  background-color: #20a5d6;
}
.scroll .scroll-holder .imageSlider::-ms-tooltip {
  display: none;
}
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .imageSlider {
    left: 50px;
  }
}
`, "",{"version":3,"sources":["webpack://./../../ui/src/components/ImageScrollbar/ImageScrollbar.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,YAAY;EACZ,UAAU;EACV,UAAU;EACV,kBAAkB;EAClB,MAAM;EACN,gCAAwB;UAAxB,wBAAwB;EACxB,kCAA0B;UAA1B,0BAA0B;EAC1B,wBAAwB;EACxB,kCAAkC;AACpC;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,kCAAkC;EAClC,YAAY;EACZ,eAAe;EACf,WAAW;EACX,UAAU;AACZ;AACA;EACE,kCAAkC;EAClC,YAAY;EACZ,eAAe;EACf,WAAW;EACX,UAAU;AACZ;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,WAAW;AACb;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mCAAmC;EACnC,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,UAAU;EACZ;AACF","sourcesContent":[".scroll {\n  height: calc(100% - 30px);\n  padding: 5px;\n  position: absolute;\n  right: 0;\n  top: 30px;\n}\n.scroll .scroll-holder {\n  height: calc(100%);\n  margin-bottom: 5px;\n  position: relative;\n  width: 12px;\n}\n.scroll .scroll-holder .imageSlider {\n  height: 12px;\n  left: 12px;\n  padding: 0;\n  position: absolute;\n  top: 0;\n  transform: rotate(90deg);\n  transform-origin: top left;\n  -webkit-appearance: none;\n  background-color: rgba(0, 0, 0, 0);\n}\n.scroll .scroll-holder .imageSlider:focus {\n  outline: none;\n}\n.scroll .scroll-holder .imageSlider::-moz-focus-outer {\n  border: none;\n}\n.scroll .scroll-holder .imageSlider::-webkit-slider-runnable-track {\n  background-color: rgba(0, 0, 0, 0);\n  border: none;\n  cursor: pointer;\n  height: 5px;\n  z-index: 6;\n}\n.scroll .scroll-holder .imageSlider::-moz-range-track {\n  background-color: rgba(0, 0, 0, 0);\n  border: none;\n  cursor: pointer;\n  height: 2px;\n  z-index: 6;\n}\n.scroll .scroll-holder .imageSlider::-ms-track {\n  animate: 0.2s;\n  background: transparent;\n  border: none;\n  border-width: 15px 0;\n  color: rgba(0, 0, 0, 0);\n  cursor: pointer;\n  height: 12px;\n  width: 100%;\n}\n.scroll .scroll-holder .imageSlider::-ms-fill-lower {\n  background: rgba(0, 0, 0, 0);\n}\n.scroll .scroll-holder .imageSlider::-ms-fill-upper {\n  background: rgba(0, 0, 0, 0);\n}\n.scroll .scroll-holder .imageSlider::-webkit-slider-thumb {\n  -webkit-appearance: none !important;\n  background-color: #163239;\n  border: none;\n  border-radius: 57px;\n  cursor: -webkit-grab;\n  height: 12px;\n  margin-top: -4px;\n  width: 39px;\n}\n.scroll .scroll-holder .imageSlider::-webkit-slider-thumb:active {\n  background-color: #20a5d6;\n  cursor: -webkit-grabbing;\n}\n.scroll .scroll-holder .imageSlider::-moz-range-thumb {\n  background-color: #163239;\n  border: none;\n  border-radius: 57px;\n  cursor: -moz-grab;\n  height: 12px;\n  width: 39px;\n  z-index: 7;\n}\n.scroll .scroll-holder .imageSlider::-moz-range-thumb:active {\n  background-color: #20a5d6;\n  cursor: -moz-grabbing;\n}\n.scroll .scroll-holder .imageSlider::-ms-thumb {\n  background-color: #163239;\n  border: none;\n  border-radius: 57px;\n  cursor: ns-resize;\n  height: 12px;\n  width: 39px;\n}\n.scroll .scroll-holder .imageSlider::-ms-thumb:active {\n  background-color: #20a5d6;\n}\n.scroll .scroll-holder .imageSlider::-ms-tooltip {\n  display: none;\n}\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .imageSlider {\n    left: 50px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
